/**
 * Durum rozeti — **parmak** mertebesi.
 *
 * Rengi KENDİ SEÇMEZ: sunucudan gelen `statusTone` değeri
 * `src/domain/state-machine.ts` → `STATUS_PRESENTATION` tablosundan gelir.
 * Böylece "hangi durum hangi renk" sorusunun tek bir cevabı olur; arayüz ile
 * iş mantığı ayrışmaz (docs/13-TASARIM-SISTEMI.md bölüm 6).
 *
 * Etiket de sunucudan gelir — panelde "GIB_REPORTED" gibi bir kod GÖRÜNMEZ.
 *
 * Yatay dolgu dikeyin ~1.6 katı (doküman 5): hap biçimli rozette eşit dolgu
 * dar görünür.
 */

import { cn } from '../lib/cn';
import type { DurumTonu } from '../lib/api';

const TON: Record<DurumTonu, string> = {
  success: 'bg-[var(--state-ok-soft)] text-[var(--state-ok)]',
  warning: 'bg-[var(--state-wait-soft)] text-[var(--state-wait)]',
  danger: 'bg-[var(--state-bad-soft)] text-[var(--state-bad)]',
  info: 'bg-[var(--state-info-soft)] text-[var(--state-info)]',
  neutral: 'bg-[var(--state-done-soft)] text-[var(--state-done)]',
};

export interface DurumRozetiProps {
  etiket: string;
  ton: DurumTonu;
  /** Uzun açıklama — fare üstüne gelince görünür (tablo satırında yer yok). */
  aciklama?: string;
  className?: string;
}

export function DurumRozeti({ etiket, ton, aciklama, className }: DurumRozetiProps) {
  return (
    <span
      title={aciklama}
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5',
        'text-xs font-semibold whitespace-nowrap',
        TON[ton],
        className
      )}
    >
      {/* Renk tek başına bilgi taşımaz (renk körlüğü): nokta + metin birlikte. */}
      <span className="size-1.5 shrink-0 rounded-full bg-current" aria-hidden="true" />
      {etiket}
    </span>
  );
}

/** Belge tipi etiketi — durum değil, sınıflandırma. Bu yüzden nötr. */
export function TipRozeti({ etiket, className }: { etiket: string; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-[var(--radius-sm)] px-1.5 py-0.5',
        'border border-[var(--line-strong)] bg-[var(--surface-sunken)]',
        'text-xs font-medium text-[var(--ink-muted)] whitespace-nowrap',
        className
      )}
    >
      {etiket}
    </span>
  );
}
